import React from 'react';
import { Box, Container, Typography, Stack } from '@mui/material';

const Privacy = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', py: 10 }}>
            <Container maxWidth="md">
                <Typography variant="h3" sx={{ fontWeight: 900, mb: 6 }}>Privacy Policy</Typography>
                <Stack spacing={4} sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>1. Data Collection</Typography>
                        <Typography variant="body1">
                            We collect basic account information and social media tokens required to perform automation tasks.
                            Lead data captured via AI is stored securely within your private Firestore project.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>2. Platform Connectivity</Typography>
                        <Typography variant="body1">
                            When you connect your social media accounts via OAuth, we only request the minimum permissions
                            necessary to perform actions on your behalf (posting, comment management).
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>3. AI Usage</Typography>
                        <Typography variant="body1">
                            Your social media comments and post content may be processed by Google Gemini for intent detection
                            and content optimization. This data is not used to train global AI models.
                        </Typography>
                    </Box>

                    <Box>
                        <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 800, mb: 2 }}>4. Security</Typography>
                        <Typography variant="body1">
                            All API credentials and user data are stored using industry-standard security practices provided
                            by Google Firebase.
                        </Typography>
                    </Box>
                </Stack>
            </Container>
        </Box>
    );
};

export default Privacy;
